import { render } from "./EmptySearch.vue?vue&type=template&id=d2718130&ts=true"
import script from "./EmptySearch.vue?vue&type=script&lang=ts"
export * from "./EmptySearch.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__